import { Box } from '@mui/material';
import SectionHeader from 'src/components/SectionHeader';
import WebFilingDatatable from 'src/components/WebFilingDatatable';
export default function WebfilingSection() {
  return (
    <Box>
      <SectionHeader title="Personal Property Tax Web Filing Search" />
      <WebFilingDatatable />
    </Box>
  );
}
